module.exports = __webpack_public_path__ + "static/media/sitemap.97737a12.xml";